module.exports = __webpack_public_path__ + "img/D2-2-2-img01-en.d9252a04.jpg";